import { useCallback, useEffect, useState } from "react";
import { Inbox } from "lucide-react";
import { toast } from "sonner";
import { AppHeader } from "../components/AppHeader";
import { HotelSelect } from "../components/HotelSelect";
import { ResolveDialog } from "../components/ResolveDialog";
import { FeedbackCard } from "../components/FeedbackCard";
import { api, errMsg } from "../lib/api";

export default function PendingReviews() {
  const [hotel, setHotel] = useState(localStorage.getItem("tamanna_hotel") || "All");
  const [items, setItems] = useState(null);
  const [resolving, setResolving] = useState(null);

  const load = useCallback(async () => {
    try {
      const r = await api.get("/feedback/pending", { params: { hotel } });
      setItems(r.data);
    } catch (e) { toast.error(errMsg(e)); }
  }, [hotel]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="relative z-10 min-h-screen">
      <AppHeader><div className="hidden sm:block"><HotelSelect value={hotel} onChange={setHotel} allowAll testId="pending-hotel-filter" /></div></AppHeader>
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="rise mb-8">
          <div className="eyebrow">Guest recovery</div>
          <h1 className="mt-2 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-emerald-950">Pending reviews</h1>
          <p className="mt-3 text-slate-600 max-w-xl">Ratings below 3 stars wait here until someone follows up with the guest and resolves them with remarks.</p>
          <div className="sm:hidden mt-4"><HotelSelect value={hotel} onChange={setHotel} allowAll testId="pending-hotel-filter-mobile" /></div>
          {items && <div className="mt-4 text-sm font-semibold text-red-600" data-testid="pending-count">{items.length} pending</div>}
        </div>
        {items && items.length === 0 && (
          <div className="glass rounded-3xl p-12 text-center" data-testid="pending-empty">
            <Inbox className="mx-auto h-10 w-10 text-emerald-600" />
            <div className="mt-3 font-display text-xl font-extrabold text-emerald-950">All caught up</div>
            <p className="text-sm text-slate-500">No pending low-rating reviews{hotel !== "All" ? ` for ${hotel}` : ""}.</p>
          </div>
        )}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {(items || []).map((i) => <FeedbackCard key={i.id} i={i} onResolve={setResolving} prefix="pending" />)}
        </div>
      </main>
      <ResolveDialog item={resolving} onClose={() => setResolving(null)} onDone={load} />
    </div>
  );
}
